import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import SeoManager from "@/components/feature/SeoManager";

export default function SiteLayout() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        const frame = requestAnimationFrame(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        return () => cancelAnimationFrame(frame);
      }
    }
    window.scrollTo(0, 0);
    /* `key` changes on every navigation, so clicking the link for the page you
       are already on still returns the reader to the top. */
  }, [pathname, hash, key]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SeoManager />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}